import LeftImage from "../../magic_bg_page/anime-generator/LeftImage";
import RightImage from "../../magic_bg_page/anime-generator/RightImage";
import FileInput from "../FileInput/FileInput";
import MainBlock from "../MainBlock/MainBlock";
import FaqComponent from "../../FaqComponent/FaqComponent";
import { sketchMainData } from "../constants";
import { sketchLeftBlock1, sketchLeftBlock2, sketchRightBlock } from "../constants";

function SketchLayout({ dictionary, isLoading, uploadFile, checkNonAuth }) {
	return (
		<>
			<MainBlock dictionary={dictionary} mainBlockData={sketchMainData}>
				<FileInput {...{ uploadFile, dictionary, checkNonAuth }} loading={isLoading} creditCost={"1_credit"} />
			</MainBlock>
			<LeftImage dictionary={dictionary} blockData={sketchLeftBlock1} />
			<RightImage dictionary={dictionary} blockData={sketchRightBlock} />
			<LeftImage dictionary={dictionary} blockData={sketchLeftBlock2} />
			<FaqComponent dictionary={dictionary} pageName={"page_sketch"} isPurpleBack={true} />
		</>
	);
}

export default SketchLayout;
